<div class="pointPickerDropdown">
  @if (hasMultiStepDropdownFeatureFlagEnabled) {
    <pp-multi-step-dropdown
      [ppSteps]="steps"
      [ppBackCallback]="back"
      [ppIsLoading]="processing"
      [ppSelectedId]="selectedPointId"
      [ppSelectedParentId]="selectedWorkspaceId"
    />
  } @else {
    <pp-search-box
      [ppPlaceholder]="'search_sites' | ppTranslate"
      (ppAction)="setKeyword($event)"
      [ppFocusOnInit]="true"
      ppSize="wide"
      class="dropdown__searchBar"
      ppColor="#667085"
    ></pp-search-box>

    @if (!pickedWorkspace) {
      <section class="pointPickerDropdown__list">
        @for (account of filteredAccounts; track account.id) {
          <div class="pointPickerDropdown__account" (click)="toggleAccount(account.id).subscribe()">
            <div class="pointPickerDropdown__item">
              {{ account.name }}
            </div>
          </div>
          @if (!collapsedAccounts[account.id]) {
            @for (workspace of account.workspaces; track workspace.id) {
              <div
                class="pointPickerDropdown__workspace"
                (click)="openWorkspace(workspace.id).subscribe()"
              >
                <div class="pointPickerDropdown__item">
                  {{ workspace.name }}
                </div>
              </div>
            }
          }
        }
      </section>
    }

    @if (pickedWorkspace) {
      <section class="pointPickerDropdown__list">
        <button class="pointPicker__backButton" (click)="back()">
          <pp-icon
            [ppSrc]="EIconPath.ICON_LEFT_MENU_ARROW_BACK_14"
            ppColor="inherit"
            ppClass="setSize14"
          />
          <p class="dashletHead__backButton--text">
            {{ 'back' | ppTranslate }}
          </p>
        </button>
        <div class="pointPickerDropdown__workspace">
          <div class="pointPickerDropdown__item">
            {{ pickedWorkspace.name }}
          </div>
        </div>
        @if (processing) {
          <pp-spinner data-testid="workspace-loading-spinner"></pp-spinner>
        }
        @for (point of filteredPoints; track point.id) {
          <div class="pointPickerDropdown__account" (click)="selectPoint(point.id)">
            <div class="pointPickerDropdown__item">
              {{ point.sequenceNumber }}. {{ point.title }}
            </div>
          </div>
        }
      </section>
    }
  }
</div>
